export const CONNECT_FORM_WIDTH = '500px'

export const CONNECT_PADDING = {
  EXT: 15,
  /** So that the buttons shadow is not cut */
  INT: 5,
} as Record<'EXT' | 'INT' | 'TOTAL', number>
CONNECT_PADDING.TOTAL = CONNECT_PADDING.EXT + CONNECT_PADDING.INT

export enum CONNECT_INPUT_ID {
  EMAIL = 'connect-form-email-input',
  PASSWORD = 'connect-form-password-input',
  NAME = 'connect-form-name-input',
}

export const STEP_INPUT_IDS = {
  email: CONNECT_INPUT_ID.EMAIL,
  password: CONNECT_INPUT_ID.PASSWORD,
  name: CONNECT_INPUT_ID.NAME,
}

export type TConnectStep = keyof typeof STEP_INPUT_IDS

export const CONNECT_STEP_ORDER: TConnectStep[] = ['email', 'password', 'name']

export const CONNECT_STEP_CLASS = 'connect-step'
